/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { ItemCard, ZeroResults } from 'components';
import { DesktopAd, TabletAd, MobileAd } from './ads/search-results-ads';
import uiActions from 'state/actions/ui';
import qs from 'qs';
import './search-results.scss';
import * as gtm from './search-gtm';
import GtmService from 'static/script/app/ui/google-tagmanager-service';
import { BPOINT, breakPoints } from 'constants/breakpoints';

const DESKTOP_AD_OFFSET = 0;
const TABLET_AD_OFFSET = 0;
const MOBILE_AD_OFFSET = 6;
const AD_FREQUENCY = 12;

//@TODO Break me out of this file.
const LoadingSymbolSpinner = () => (
    <div className={`col-12 text-center loader-container`}>
        <img
            className={`d-flex mx-auto`}
            src="//static.tradera.net/touchweb/static/fallback/item-card.gif"
        />
    </div>
);

class SearchResults extends React.Component {
    static propTypes = {
        gptData: PropTypes.object.isRequired,
        queryParams: PropTypes.object.isRequired,
        searchResults: PropTypes.object,
        fetching: PropTypes.bool,
        itemLayout: PropTypes.string,
        pageType: PropTypes.string,
        adsEnabled: PropTypes.bool,
        pageIndex: PropTypes.number
    };

    static defaultProps = {
        adsEnabled: false
    };

    constructor(props) {
        super(props);
    }

    saveSearchPayload = queryParams => {
        const newQueryParams = {
            savedQueryName: queryParams['q'],
            ...queryParams
        };

        const payload = {
            data: qs.stringify(newQueryParams, { encode: false })
        };

        return payload;
    };

    handleQuickViewClick = itemId => {
        const {
            dispatch,
            searchResults: { itemsById }
        } = this.props;

        gtm.trackAction('Quick View', 'Open: from Search Results');
        dispatch(uiActions.openQuickView({ itemIds: itemsById, itemId }));
    };

    trackAddToWishlist = () => {
        const { pageType } = this.props;
        GtmService.trackAction('Wishlist Item', `Add From ${pageType}`);
    };

    trackRemoveFromWishlist = () => {
        const { pageType } = this.props;
        GtmService.trackAction('Wishlist Item', `Remove From ${pageType}`);
    };

    renderItemsAndStitchAds = (
        items,
        gptData,
        itemLayout,
        pageIndex,
        adsEnabled
    ) => {
        const { dispatch } = this.props;
        let result = [];
        let mobileAdIndex = 0;
        let tabletAdIndex = 0;
        let desktopAdIndex = 0;

        if (!(items && items.length > 0)) {
            return null;
        }

        for (const [index, item] of items.entries()) {
            if (adsEnabled && pageIndex > 0) {
                if ((index - MOBILE_AD_OFFSET) % AD_FREQUENCY === 0) {
                    result.push(
                        <MobileAd
                            key={`mobile-ad-${mobileAdIndex}-${pageIndex}`}
                            gptData={gptData}
                            index={mobileAdIndex}
                        />
                    );
                    mobileAdIndex += 1;
                }
                if ((index - TABLET_AD_OFFSET) % AD_FREQUENCY === 0) {
                    result.push(
                        <TabletAd
                            key={`tablet-ad-${tabletAdIndex}-${pageIndex}`}
                            gptData={gptData}
                            index={tabletAdIndex}
                            autoscale={true}
                            autoscaleOffsetWidth={735}
                        />
                    );
                    tabletAdIndex += 1;
                }
                if ((index - DESKTOP_AD_OFFSET) % AD_FREQUENCY === 0) {
                    result.push(
                        <DesktopAd
                            key={`desktop-ad-${desktopAdIndex}-${pageIndex}`}
                            gptData={gptData}
                            index={desktopAdIndex}
                            autoscale={true}
                            autoscaleOffsetWidth={980}
                        />
                    );
                    desktopAdIndex += 1;
                }
            }

            result.push(
                <ItemCard
                    key={item.itemId}
                    dispatch={dispatch}
                    ready={!!item.itemUrl}
                    item={item}
                    lazy={{
                        offset: 400,
                        once: true,
                        height: 0
                    }}
                    handleQuickViewClick={this.handleQuickViewClick}
                    itemLayout={itemLayout}
                    onRemoveFromWishlist={this.trackRemoveFromWishlist}
                    onAddToWishlist={this.trackAddToWishlist}
                />
            );
        }

        return result;
    };

    render() {
        const {
            gptData,
            queryParams,
            items,
            fetching,
            itemLayout,
            pageIndex,
            adsEnabled
        } = this.props;
        return (
            <div
                data-search-results-items
                className={`${itemLayout} ${
                    items && items.length > 12
                        ? 'search-results pb-4'
                        : 'few-results pb-4'
                }`}>
                {fetching ? (
                    <LoadingSymbolSpinner />
                ) : items && items.length > 0 ? (
                    <section>
                        <div className="card-list row mx-auto mb-4">
                            {this.renderItemsAndStitchAds(
                                items,
                                gptData,
                                itemLayout,
                                pageIndex,
                                adsEnabled
                            )}
                        </div>
                    </section>
                ) : (
                    <div>
                        <ZeroResults searchTerm={queryParams.q} />
                        <DesktopAd
                            gptData={gptData}
                            index={99}
                            adContainerClass="mt-3"
                            lazyload={false}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default SearchResults;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/search-results/search-results.jsx